import countriesLib from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

countriesLib.registerLocale(enLocale)

const flagEmojiSupported: boolean = (() => {
    try {
        if (typeof CanvasRenderingContext2D === 'undefined') return false
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        if (!ctx) return false
        ctx.font = '16px serif'
        const single = ctx.measureText('🇬').width
        const pair = ctx.measureText('🇬🇧').width
        return pair / single < 1.5
    } catch {
        return false
    }
})()

const toFlagEmoji = (alpha2: string): string => {
    if (!flagEmojiSupported) return ''
    if (!countriesLib.getName(alpha2, 'en')) return ''
    return [...alpha2.toUpperCase()].map(c => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65)).join('')
}

/** "🇬🇧 GB" — flag + code. Falls back to bare code if flag unavailable. */
export const countryShortLabel = (code: string): string => {
    const upper = code.toUpperCase()
    const alpha2 = upper.length === 3 ? (countriesLib.alpha3ToAlpha2(upper) ?? upper) : upper
    const flag = alpha2.length === 2 ? toFlagEmoji(alpha2) : ''
    return flag ? `${flag} ${upper}` : upper
}

/** Flag emoji only, or empty string if unsupported or unrecognised. */
export const countryFlag = (code: string): string => {
    const upper = code.toUpperCase()
    const alpha2 = upper.length === 3 ? (countriesLib.alpha3ToAlpha2(upper) ?? upper) : upper
    return alpha2.length === 2 ? toFlagEmoji(alpha2) : ''
}

/** "🇬🇧" — flag only. Falls back to bare code if flag unavailable. */
export const countryFlagLabel = (code: string): string => {
    const upper = code.toUpperCase()
    const alpha2 = upper.length === 3 ? (countriesLib.alpha3ToAlpha2(upper) ?? upper) : upper
    const flag = alpha2.length === 2 ? toFlagEmoji(alpha2) : ''
    return flag || upper
}

/** "🇬🇧 GB — United Kingdom" — flag, code, and full English name. Falls back to bare code if unrecognised. */
export const countryTooltipLabel = (code: string): string => {
    const upper = code.toUpperCase()
    const alpha2 = upper.length === 3 ? (countriesLib.alpha3ToAlpha2(upper) ?? upper) : upper
    const name = countriesLib.getName(upper, 'en')
    const flag = alpha2.length === 2 ? toFlagEmoji(alpha2) : ''
    return name ? `${flag}${flag ? ' ' : ''}${upper} — ${name}` : upper
}
